import { render, staticRenderFns } from "./SharedCPDListItem.vue?vue&type=template&id=6b1748c1&scoped=true&"
import script from "./SharedCPDListItem.vue?vue&type=script&lang=js&"
export * from "./SharedCPDListItem.vue?vue&type=script&lang=js&"
import style0 from "./SharedCPDListItem.vue?vue&type=style&index=0&id=6b1748c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1748c1",
  null
  
)

export default component.exports